type WantedEntryIdentity = {
  readonly nurse_id: string;
  readonly shift_date: string;
};

export function mergeWantedEntryOverrides<T extends WantedEntryIdentity>(
  entries: readonly T[],
  overrides: ReadonlyMap<string, T | null>
): T[] {
  const entriesByKey = new Map(
    entries.map((entry) => [`${entry.nurse_id}_${entry.shift_date}`, entry])
  );

  overrides.forEach((entry, key) => {
    if (entry) {
      entriesByKey.set(key, entry);
      return;
    }
    entriesByKey.delete(key);
  });

  return Array.from(entriesByKey.values());
}
